module.exports = __webpack_public_path__ + "static/media/java1.ae58d7c0.png";